/* ============
 * Mutations for the reportsmodule
 * ============
 *
 * The mutations that are available on the
 * reports module.
 */
import types from './mutation-types';

export default {
  [types.FETCH_ENROLLED_PATIENT_REPORT_LIST](state) {
    state.isReportsLoading = true;
  },
  [types.FETCH_ENROLLED_PATIENT_REPORT_SUCCESS](state, response) {
    state.isReportsLoading = false;
    state.totalCount = response.patientsCount;
    state.reports = response.patients;
  },
  [types.FETCH_ENROLLED_PATIENT_REPORT_FAIL](state, error) {
    state.isReportsLoading = false;
    state.error = error;
  },
  [types.FETCH_RESOLVED_PATIENT_REPORT_LIST](state) {
    state.isResolvedsymptomsLoading = true;
  },
  [types.FETCH_RESOLVED_PATIENT_REPORT_SUCCESS](state, response) {
    state.isResolvedsymptomsLoading = false;
    state.resolvedtotalCount = response.alertsCount;
    state.resolvedsymptoms = response.alerts;
  },
  [types.FETCH_RESOLVED_PATIENT_REPORT_FAIL](state, error) {
    state.isResolvedsymptomsLoading = false;
    state.error = error;
  },
  [types.FETCH_SYMPTOMS_PATIENT_REPORT_LIST](state) {
    state.issymptomsLoading = true;
  },
  [types.FETCH_SYMPTOMS_PATIENT_REPORT_SUCCESS](state, response) {
    state.issymptomsLoading = false;
    state.symptomstotalCount = response.alertsCount;
    state.symptoms = response.alerts;
  },
  [types.FETCH_SYMPTOMS_PATIENT_REPORT_FAIL](state, error) {
    state.issymptomsLoading = false;
    state.error = error;
  },
  [types.FETCH_ALL_PATIENT_REPORT_LIST](state) {
    state.isallpatientsLoading = true;
  },
  [types.FETCH_ALL_PATIENT_REPORT_SUCCESS](state, response) {
    state.isallpatientsLoading = false;
    state.allpatientstotalCount = response.totalCount;
    state.allpatients = response.patients;
  },
  [types.FETCH_ALL_PATIENT_REPORT_FAIL](state, error) {
    state.isallpatientsLoading = false;
    state.error = error;
  },

  [types.FETCH_PATIENTBYID_REPORT_LIST](state) {
    state.ispatientbyidreportLoading = true;
  },
  [types.FETCH_PATIENTBYID_REPORT_SUCCESS](state, response) {
    state.ispatientbyidreportLoading = false;
    state.patientbyidreport = response.report;
  },
  [types.FETCH_PATIENTBYID_REPORT_FAIL](state, error) {
    state.ispatientbyidreportLoading = false;
    state.patientbyidreport = []
    state.error = error;
  },

  [types.FETCH_PATIENTBYID_WEEKLY_REPORT_LIST](state) {
    state.isweeklyreportLoading = true;
  },
  [types.FETCH_PATIENTBYID_WEEKLY_REPORT_SUCCESS](state, response) {
    state.isweeklyreportLoading = false;
    state.weeklyreports = response.report;
  },
  [types.FETCH_PATIENTBYID_WEEKLY_REPORT_FAIL](state, error) {
    state.isweeklyreportLoading = false;
    state.weeklyreports = [];
    state.error = error;
  },
  [types.FETCH_PATIENTBYID_YEARLY_REPORT_LIST](state) {
    state.isyearlyreportLoading = true;
  },
  [types.FETCH_PATIENTBYID_YEARLY_REPORT_SUCCESS](state, response) {
    state.isyearlyreportLoading = false;
    state.yearlyreports = response.report;
  },
  [types.FETCH_PATIENTBYID_YEARLY_REPORT_FAIL](state, error) {
    state.isyearlyreportLoading = false;
    state.yearlyreports = [];
    state.error = error;
  }

};
